import { usePage } from "@hooks/usePage";
import { useEffect } from "react";
import SamplesFilter from "../components/SamplesFilter";
import { useSamplesFilters } from "@hooks/useSamplesFilters";
import TableView from "../components/TableView";
import MapView from "../components/MapView";
import ModalNewSample from "../components/modal/ModalNewSample";
import ModalEditSample from "../components/modal/ModalEditSample";

function SamplesScreen() {
  const { viewMode } = usePage();

  const {
    filters,
    appliedFilters,
    handleChange: handleFilterChange,
    apply: applyFilters,
    reset: resetFilters,
  } = useSamplesFilters();

  useEffect(() => {
    resetFilters();
  }, [viewMode, resetFilters]);

  return (
    <div className="space-y-6">
      <SamplesFilter
        filters={filters}
        onChange={handleFilterChange}
        onApply={applyFilters}
      />

      {viewMode === "map" ? (
        <MapView appliedFilters={appliedFilters} />
      ) : (
        <TableView appliedFilters={appliedFilters} />
      )}

      <ModalNewSample />
      <ModalEditSample />
    </div>
  );
}

export default SamplesScreen;
